import React from 'react';
import PropTypes from 'prop-types';

import './ProductHeader.scss';

const ProductHeaderComponent = ({ isVisible, children, mode }) => {
  const showShadow = isVisible ? '' : 'product-header-component__container--shadow';
  const modeClass = mode === 'default' ? '' : `product-header-component--${mode}`;
  return (
    <div className={`product-header-component ${modeClass}`}>
      <div className={`product-header-component__container ${showShadow}`}>{children}</div>
    </div>
  );
};

ProductHeaderComponent.displayName = 'ProductHeader';

ProductHeaderComponent.propTypes = {
  mode: PropTypes.oneOf(['default', 'thin']),
  isVisible: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

ProductHeaderComponent.defaultProps = {
  mode: 'default',
};

export default ProductHeaderComponent;
